exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".news-services-list-page.mobile .header-filter-components[data-v-47f46e92]{margin:0}.news-services-list-page .cols-cards-info[data-v-47f46e92]{margin-top:10px}", ""]);

// exports
